export enum ProcessingTypeEnum {
	SMART = 'Smart',
	TRADITIONAL = 'Tradicional',
	SINGLE_TREES = 'SingleTrees',
}
